import React, { useState } from "react";
import { IoArrowUpSharp, IoArrowDownSharp } from "react-icons/io5";


const LocationstrHeader = ({ setSortBy, setOrder,sortBy,order }) => {
 
function handleSortClick(field){
  if(field===sortBy){
    setOrder(order === "asc" ? "desc" : "asc")
  }else{
    setSortBy(field);
    setOrder("desc");
  }
}

function renderSortIcon(field) {
  if(field===sortBy){
    return (
      <IoArrowUpSharp
      className={`inline ml-1 transition-transform duration-300 ${order==="desc"?"rotate-180":""}  `}
      size={16}
    />
    )
  }
  return  <IoArrowUpSharp
  className={`inline ml-1  `}
  size={16}
/>
}
  return (
    <tr className="text-white">
      <th className="py-4 px-6 text-left cursor-pointer" onClick={()=>handleSortClick("displayName")}>Name  {renderSortIcon("displayName")}</th>
      <th className="py-4 px-6 text-left w-1/4">Address</th>
      <th className="py-4 px-6 text-left">Status</th>
      <th className="py-4 px-6 text-left cursor-pointer" onClick={()=>handleSortClick("createdAt")} >
        Created
        {renderSortIcon("createdAt")}
      </th>
      <th className="py-4 px-6 text-left cursor-pointer" onClick={()=>handleSortClick("updatedAt")}>
        Last Modified
        {renderSortIcon("updatedAt")}
      </th>
      
      <th className="py-4 px-6 text-left">Edit</th>
      <th className="py-4 px-6 text-left">Toggle Status</th>
    </tr>
  );
};

export default LocationstrHeader;
